import { InboxOutlined } from "@ant-design/icons";
import { Button, Form, Input, Layout, Modal, Select, Typography, Upload } from "antd";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { GoDot } from "react-icons/go";
import { ImAttachment } from "react-icons/im";
import { IoSend } from "react-icons/io5";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Sender from "./Card/Reciver";
import Reciver from "./Card/Sender";

import { error, success } from "../../../common/Alerts/Message";
import Loader from "../../../common/cards/Loader";
import {
  GetAllDraftedCampaigns,
  GetSingleCampaignWithActivities
} from "../../../Config/API/campaigns";
import { GetMessagesData } from "../../../Config/API/chat";
import {
  acceptContract,
  getContract,
  GetSingleSponsor,
  sendContract
} from "../../../Config/API/sponsor";
import MainMobile from "../MainMobile";
import { KEYS } from "../../../Config/Keys";
import fileDownload from "js-file-download";
import axios from "axios";
import ContractDetailsModal from "../ContractDetailsModal";

const { Title, Text } = Typography;
const { Header, Footer, Content } = Layout;
const { Option } = Select;
const { Dragger } = Upload;

const ChatRoomMain = ({
  setactive,
  socket,
  sponsorId,
  setSponsorId,
  active,
  openChat,
  online,
  room,
  isDesktop
}) => {
  const bottomRef = useRef(null);
  const [MainTextField, setMainTextField] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const { id } = useParams();
  const profileID = id ? id : localStorage.getItem("ProfileID");
  const [form] = Form.useForm();

  const onSubmit = (values) => {
    const messageText = values?.search || MainTextField;

    if (!messageText) {
      return error("Message field can't be empty");
    }

    const users = room.split("@!@!2!@!@");
    let role = JSON.parse(localStorage.getItem("userDetails"))?.role.toLowerCase();
    let receiverEnd = openChat.receiver.player
      ? "player"
      : openChat.receiver.sponsor
      ? "sponsor"
      : openChat.receiver.panel
      ? "panel"
      : "organizer";
    if (pathname.includes("/organizer/panel/")) {
      role = "panel";
      receiverEnd = "sponsor";
    }

    let localData = {
      sender: { [role]: { _id: profileID } },
      receiver: {
        [receiverEnd]: {
          _id: users[1] == profileID ? users[0] : users[1]
        }
      },
      text: messageText,
      createdAt: new Date(),
      room: room
    };

    setMessages((messages) => [...messages, localData]);

    setMainTextField("");
    form.resetFields();
    socket.emit("send_message", {
      data: localData,
      room: room
    });
  };

  const handleSendButtonClick = (e) => {
    e.preventDefault();
    onSubmit({ search: MainTextField });
  };

  useEffect(() => {
    socket.on("receive_message", (data) => {
      console.log("Recieve", data);
      console.log("room", localStorage.getItem("room"));
      console.log(data.room);
      if (data.room == localStorage.getItem("room")) {
        console.log("room data changed");

        setMessages((messages) => [...messages, data]);
      }
    });
  }, [socket, openChat]);

  useEffect(() => {
    setMessages([]);
    getInboxDataMessages();
  }, [active]);

  const getInboxDataMessages = async () => {
    setLoading(true);
    var res = await GetMessagesData(localStorage.getItem("room"));
    var data = await res.json();
    if (data?.result === null) {
      console.log("false");
      setMessages([]);
      return setLoading(false);
    }

    if (data.type === "success") {
      setMessages(data.result.messages);
      setLoading(false);
      // setopenChat({
      //   ...openChat, // Copy the old fields
      //   messages: [...openChat.messages, data.result.messages], // But override this one
      // });
    } else {
      console.log("Error");
      setLoading(false);
    }

    setLoading(false);
  };
  const AlwaysScrollToBottom = () => {
    const elementRef = useRef();
    useEffect(() => elementRef.current.scrollIntoView());
    return <div ref={elementRef} />;
  };

  return (
    <Fragment>
      {isDesktop ? (
        <MAIN
          setactive={setactive}
          openChat={openChat}
          online={online}
          profileID={profileID}
          loading={loading}
          sponsorId={sponsorId}
          setSponsorId={setSponsorId}
          bottomRef={bottomRef}
          messages={messages}
          onSubmit={onSubmit}
          handleSendButtonClick={handleSendButtonClick}
          form={form}
          setMainTextField={setMainTextField}
          MainTextField={MainTextField}
          AlwaysScrollToBottom={AlwaysScrollToBottom}
        />
      ) : (
        <MainMobile active={active} setactive>
          <MAIN
            setactive={setactive}
            openChat={openChat}
            online={online}
            sponsorId={sponsorId}
            setSponsorId={setSponsorId}
            profileID={profileID}
            loading={loading}
            bottomRef={bottomRef}
            messages={messages}
            onSubmit={onSubmit}
            handleSendButtonClick={handleSendButtonClick}
            form={form}
            setMainTextField={setMainTextField}
            MainTextField={MainTextField}
            AlwaysScrollToBottom={AlwaysScrollToBottom}
            mobile
          />
        </MainMobile>
      )}
    </Fragment>
  );
};

const MAIN = ({
  setactive,
  openChat,
  online,
  profileID,
  sponsorId,
  loading,
  bottomRef,
  messages,
  onSubmit,
  handleSendButtonClick,
  form,
  setMainTextField,
  MainTextField,
  AlwaysScrollToBottom,
  mobile
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isPanelChat, setIsPanelChat] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [campaignsLoading, setCampaignsLoading] = useState(false);
  const [contractLoading, setContractLoading] = useState(false);
  const [contractData, setContractData] = useState(false);
  const [activitiesLoading, setActivitiesLoading] = useState(false);
  const [contractSubmitting, setContractSending] = useState(false);
  const [isContractModalVisible, setIsContractModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [contractForm] = Form.useForm();
  useEffect(() => {
    if (openChat?.receiver?.panel) {
      if (pathname.includes("/organizer/panel/")) {
        setIsPanelChat(false);
      } else {
        setIsPanelChat(true);
        fetchCampaigns();
      }
      fetchContracts();
    } else {
      setIsPanelChat(false);
    }
  }, [openChat]);

  const fetchContracts = async () => {
    try {
      setContractLoading(true);
      const sponser = await GetSingleSponsor(sponsorId);
      const sponserData = await sponser.json();
      const response = await getContract({
        sponsorId:
          sponserData?.result?.user?.sponsor ||
          openChat?.receiver?.sponsor?._id ||
          openChat?.sender?.sponsor?._id,
        panelId: openChat?.receiver?.panel?._id || openChat?.sender?.panel?._id
      });
      const data = await response.json();
      if (data.type === "success") {
        setContractData(data.contract);
      } else {
        error("Failed to load contracts");
      }
    } catch (err) {
      console.error("Error fetching contracts:", err);
      error("Failed to load contracts");
    } finally {
      setContractLoading(false);
    }
  };

  const fetchCampaigns = async () => {
    try {
      setCampaignsLoading(true);
      const response = await GetAllDraftedCampaigns();
      const data = await response.json();

      if (data.type === "success") {
        setCampaigns(data.result);
      } else {
        error("Failed to load campaigns");
      }
    } catch (err) {
      console.error("Error fetching campaigns:", err);
      error("Failed to load campaigns");
    } finally {
      setCampaignsLoading(false);
    }
  };

  const fetchActivities = async (campaignId) => {
    try {
      setActivitiesLoading(true);
      const response = await GetSingleCampaignWithActivities(campaignId);
      const data = await response.json();
      if (data.type === "success") {
        const filteredActivities = data?.result?.[0]?.activities.filter((activity) => {
          return Object.keys(activity.panel).length === 0;
        });

        setActivities(filteredActivities);
      } else {
        error("Failed to load activities");
      }
    } catch (err) {
      console.error("Error fetching activities:", err);
      error("Failed to load activities");
    } finally {
      setActivitiesLoading(false);
    }
  };

  const handleCampaignChange = (value) => {
    contractForm.setFieldsValue({ campaign: value, activity: null });
    setSelectedCampaign(value);
    setActivities([]);
    fetchActivities(value);
  };

  const handleActivityChange = (value) => {
    contractForm.setFieldsValue({ activity: value });
  };

  const openContractModal = () => {
    setIsContractModalVisible(true);

    contractForm.resetFields();
    setSelectedCampaign(null);
    setActivities([]);
    setFileList([]);
  };

  const handleSendContract = async () => {
    try {
      await contractForm.validateFields();

      const campaignId = contractForm.getFieldValue("campaign");
      const activityData = JSON.parse(contractForm.getFieldValue("activity"));

      if (!campaignId || !activityData) {
        return error("Please select both campaign and activity");
      }

      setContractSending(true);
      const formData = new FormData();

      formData.append("activityId", activityData._id);
      formData.append("panelId", openChat?.receiver?.panel?._id || openChat?.sender?.panel?._id);
      formData.append("file", fileList);

      const response = await sendContract(formData);
      const data = await response.json();

      if (data.type === "success") {
        fetchContracts();
        onSubmit({ search: "New contract has been initiated" });
        success("Contract sent successfully");
        setIsContractModalVisible(false);
        contractForm.resetFields();
        setSelectedCampaign(null);
        setActivities([]);
        setFileList([]);
      } else {
        error(data.message || "Failed to send contract");
      }
    } catch (err) {
      console.error("Error submitting contract:", err);
      error("Failed to send contract");
    } finally {
      setContractSending(false);
    }
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    maxCount: 1,
    beforeUpload: () => false,
    accept: ".pdf,.jpg,.jpeg,.png"
  };

  const mobileLoadingstlyes = {
    position: "fixed",
    left: "0",
    top: "0",
    width: "100vw",
    minHeight: "100vh",
    display: "grid",
    placeContent: "center",
    zIndex: "10",
    background: "white"
  };
  const desktopLoadingStyles = {
    position: "absolute",
    left: "0",
    top: "-50px",
    width: "100%",
    maxWidth: "85%",
    minHeight: "100%",
    display: "grid",
    placeContent: "center",
    zIndex: "1"
  };

  const EmptyMessageCenter = (
    <Typography className="EmptyMessageCenter">
      <Text> No Messages Yet! </Text>{" "}
    </Typography>
  );
  return (
    <Layout className={`ChatRoomMain  ${mobile ? "" : undefined}`}>
      <Header className="Chat_TobBar">
        <Typography>
          <Title level={3} style={{ marginBottom: 0, fontWeight: "bold" }}>
            {online ? (
              <GoDot color="#00FF38" style={{ marginRight: "6px" }} />
            ) : (
              <GoDot color="red" style={{ marginRight: "6px" }} />
            )}

            {openChat?.sender?.player?._id === profileID ||
            openChat?.sender?.organizer?._id == profileID ||
            openChat?.sender?.sponsor?._id === profileID
              ? openChat?.receiver?.player?.name ||
                openChat?.receiver?.organizer?.name ||
                openChat?.receiver?.sponsor?.name ||
                openChat?.receiver?.panel?.name
              : openChat?.sender?.player?.name ||
                openChat?.sender?.organizer?.name ||
                openChat?.sender?.sponsor?.name ||
                openChat?.sender?.panel?.name}
          </Title>
        </Typography>

        {/* Panel Chat Contract Section */}
        {/* {isPanelChat && contractData?.status !== "approved" && ( */}
        {isPanelChat && (
          <div className="panel-contract-section">
            <Button type="primary" onClick={openContractModal}>
              Send Contract
            </Button>

            <Modal
              title="Send Contract"
              visible={isContractModalVisible}
              onOk={handleSendContract}
              onCancel={() => setIsContractModalVisible(false)}
              confirmLoading={contractSubmitting}>
              <Form form={contractForm} layout="vertical">
                <Form.Item
                  name="campaign"
                  label="Select Campaign"
                  rules={[{ required: true, message: "Please select a campaign" }]}>
                  <Select
                    placeholder="Select Campaign"
                    loading={campaignsLoading}
                    onChange={handleCampaignChange}>
                    {campaigns.map((campaign) => (
                      <Option key={campaign._id} value={campaign._id}>
                        {campaign.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="activity"
                  label="Select Activity"
                  rules={[{ required: true, message: "Please select an activity" }]}>
                  <Select
                    placeholder="Select Activity"
                    loading={activitiesLoading}
                    disabled={!selectedCampaign}
                    onChange={handleActivityChange}>
                    {activities.map((activity) => (
                      <Option key={activity._id} value={JSON.stringify(activity)}>
                        {activity.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="file"
                  label="Upload Contract File"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e.fileList}>
                  <Dragger
                    {...uploadProps}
                    onChange={(info) => {
                      setFileList(info.file);
                    }}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                      Support for a single file upload. PDF, JPG, JPEG, PNG only.
                    </p>
                  </Dragger>
                </Form.Item>
              </Form>
            </Modal>
          </div>
        )}
        {!contractLoading && contractData ? (
          <ContractDetailsModal
            contractData={contractData}
            isPanelChat={isPanelChat}
            onDownload={() => {
              axios
                .get(KEYS.API + "/" + contractData.document.file, {
                  headers: { authorization: `Bearer ${localStorage.getItem("userToken")}` },
                  responseType: "blob"
                })
                .then((res) => {
                  const type = contractData.document.file.split(".").pop();
                  fileDownload(res.data, `contract.${type}`);
                });
            }}
            onAccept={async () => {
              const res = await acceptContract({
                _id: contractData._id,
                activityId: contractData.activityId._id
              });
              const data = await res.json();

              if (data.type === "success") {
                onSubmit({ search: "Panel has accepted the contract" });
                navigate(`/organizer/editevent/${data?.event?._id}`, { replace: true });
              }
            }}
          />
        ) : null}
        <Typography>
          <Title level={4}>
            <BiArrowBack
              cursor={"pointer"}
              onClick={() => {
                if (pathname.includes("player")) {
                  setactive("");
                  navigate(`/player/messages/chat`);
                } else if (pathname.includes("sponsor")) {
                  setactive("");
                  navigate(`/sponsor/messages/chat`);
                } else {
                  setactive("");
                  navigate(`/organizer/messages/chat`);
                }
              }}
            />
          </Title>
        </Typography>
      </Header>
      <Content
        className={`ChatContent ${mobile ? "ChatContentMobile" : undefined}`}
        ref={bottomRef}>
        {loading ? (
          <div style={mobile ? mobileLoadingstlyes : desktopLoadingStyles}>
            <Loader noShadow smaller />
          </div>
        ) : (
          <div
            style={{
              zIndex: loading ? "-1" : "1",
              minHeight: loading ? "0px" : undefined,
              overflow: loading ? "hidden" : undefined
            }}>
            {messages?.length === 0 && !loading ? EmptyMessageCenter : null}
            {messages.map((item, i) => (
              <>
                {item.sender?.player?._id === profileID ||
                item.sender.organizer?._id === profileID ||
                item.sender?.sponsor?._id === profileID ||
                item.sender?.panel?._id === profileID ? (
                  <Sender key={i} item={item} />
                ) : (
                  <Reciver openChat={openChat} key={i} item={item} />
                )}
              </>
            ))}
          </div>
        )}

        <AlwaysScrollToBottom />
      </Content>

      <Footer className="ChatFooter">
        <Form name="Main" className="MainForm" onFinish={onSubmit} form={form}>
          <Form.Item style={{ flex: 1 }} name="search">
            <Input
              className="ChatSearchBar"
              placeholder="Send Message"
              name="textfield"
              value={MainTextField}
              onChange={(e) => setMainTextField(e.target.value)}
              size="large"
              style={{ padding: "12px 15px" }}
              suffix={
                <IoSend
                  color={"var(--blue)"}
                  cursor="pointer"
                  fontSize={"1.4rem"}
                  onClick={handleSendButtonClick}
                />
              }
            />
          </Form.Item>
          <Form.Item>
            <ImAttachment color={"var(--blue)"} cursor="pointer" fontSize={"1.5rem"} />
          </Form.Item>
        </Form>
      </Footer>
    </Layout>
  );
};

export default ChatRoomMain;
